/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function */
import { createContext } from "react";
import constants from "../constants";

const { ERROR_MESSAGE, SUCCESS_MESSAGE, INFO_MESSAGE, WARNING_MESSAGE } =
  constants.status;

const initialStatus = {
  errorMessage: "",
  successMessage: "",
  infoMessage: "",
  warningMessage: "",
};

const StatusContext = createContext({
  updateErrorMessage: (errorMessage = new Error("") || "") => {},
  updateSuccessMessage: (successMessage = "") => {},
  updateInfoMessage: (infoMessage = "") => {},
  updateWarningMessage: (warningMessage = "") => {},
  ...initialStatus,
});

const statusReducer = (prevStatus, action) => {
  switch (action.type) {
    case ERROR_MESSAGE:
      return {
        ...prevStatus,
        errorMessage: action.errorMessage,
      };
    case SUCCESS_MESSAGE:
      return {
        ...prevStatus,
        successMessage: action.successMessage,
      };
    case INFO_MESSAGE:
      return {
        ...prevStatus,
        infoMessage: action.infoMessage,
      };
    case WARNING_MESSAGE:
      return {
        ...prevStatus,
        warningMessage: action.warningMessage,
      };
    default:
      return prevStatus;
  }
};

export { initialStatus, StatusContext, statusReducer };
